import { globalHeaders } from "../global-headers";

export type FrontendConfig = {
	sentryDsn: string | null;
	environment: string | null;
	release: string | null;
	/** A genuine reply newer than this many days marks a person as a warm contact. */
	warmContactReplyWindowDays: number | null;
	/** Non-prod instance with the import-from-prod admin feature enabled. */
	prodImportEnabled?: boolean;
	/** Current employees a company import carries (PROD_IMPORT_COMPANY_PERSON_LIMIT). */
	prodImportCompanyPersonLimit?: number;
	/** Cloud sessions may upload UI mockups; off means plans never get one. */
	workflowMockupsEnabled?: boolean;
	/** The ticket workflow is on (WORKFLOW_ENABLED); off hands support tickets to Trello. */
	workflowEnabled?: boolean;
	/** "Continue with Google" is offered (GOOGLE_SIGN_IN_ENABLED). */
	googleSignInEnabled?: boolean;
};

const endpoint = "/api/v2/frontend-config/";

const requestFrontendConfig = async (): Promise<FrontendConfig> => {
	const response = await fetch(endpoint, {
		headers: globalHeaders,
	});

	if (!response.ok) {
		throw new Error(`Failed to load frontend config: ${response.status}`);
	}

	return (await response.json()) as FrontendConfig;
};

/** The settings this build was served with; they cannot change under an open tab. */
let pendingConfig: Promise<FrontendConfig> | null = null;

/**
 * Seven components each fetched this on mount, so one page load asked three or
 * four times over for the same payload. They now share one request per session.
 */
export const fetchFrontendConfig = (): Promise<FrontendConfig> => {
	if (!pendingConfig) {
		pendingConfig = requestFrontendConfig().catch((error: unknown) => {
			// A failed load has to stay retryable: index.tsx retries this call up
			// to 60 times while the backend is still coming up.
			pendingConfig = null;
			throw error;
		});
	}
	return pendingConfig;
};
